import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import classNames from 'classnames/bind';
import { Picture } from "../../../Picture";
import { Carousel } from "../../../Carousel";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var FALLBACK_PICTURE_LINK = 'https://static.beeline.ru/upload/images/error-content-sky.png';
var paginationControl = function paginationControl(className) {
  return "\n  <div\n    class=\"".concat(cx(className, 'pagination'), "\"\n  >\n  </div>");
};
export var Slider = function Slider(_ref) {
  var pictures = _ref.pictures,
    control = _ref.control;
  var _pictures = _slicedToArray(pictures, 1),
    picture = _pictures[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, control, pictures.length > 1 ? /*#__PURE__*/React.createElement(Carousel, {
    className: style.swiper,
    paginatePadding: false,
    settings: {
      pagination: {
        clickable: true,
        renderBullet: function renderBullet(index, className) {
          return paginationControl(className);
        }
      },
      slidesPerView: 1,
      loop: true
    }
  }, pictures.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('wrapper'),
      key: "".concat(item.src)
    }, /*#__PURE__*/React.createElement(Picture, _extends({}, item, {
      fallbackSrc: FALLBACK_PICTURE_LINK,
      src: item.src
    })));
  })) : /*#__PURE__*/React.createElement("div", {
    className: cx('picture-wrapper'),
    key: "".concat(picture.src)
  }, /*#__PURE__*/React.createElement(Picture, _extends({}, picture, {
    fallbackSrc: FALLBACK_PICTURE_LINK,
    src: picture.src
  }))));
};